import React from 'react';
import { Loader2 } from 'lucide-react';

export function InitialLoading() {
  return (
    <div className="fixed inset-0 bg-light dark:bg-dark flex items-center justify-center z-50">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary-600 dark:text-primary-400 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Loading Data
        </h2>
        <p className="text-gray-600 dark:text-gray-400">
          Please wait while we prepare your workspace...
        </p>
      </div>
    </div>
  );
}